<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper" @click.self="$emit('close')">
        <div
          class="modal-container"
          :class="[{ 'zoom-in-modal-container-class': zoomInActive }, { 'image-zoom-active-class': imageZoomActive }]"
          :style="'width:' + modalWidth + ';' + 'height:' + modalHeight + ';'"
        >
          <button
            type="close"
            :title="getTooltips['close']"
            @click="closeZoomIn"
            name="close"
            class="close-button"
            :class="[{ 'zoom-in-close-button': zoomInActive }, { 'zoom-in-close-button': imageZoomActive }]"
          >
            <!-- <img src="~@/assets/icons/ic_close_white_64px.svg" /> --><svg
              fill="#ffffff"
              height="64"
              viewBox="0 0 24 24"
              width="64"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
                fill="rgb(144, 144, 144)"
              />
              <!-- <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" fill="rgb(255, 200, 0)"/> -->
              <path d="M0 0h24v24H0z" fill="none" />
            </svg>
          </button>
          <div
            class="modal-body"
            :class="[{ 'zoom-in-modal-body-class': zoomInActive }, { 'image-zoom-active-class': imageZoomActive }]"
          >
            <slot name="body"> default body </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script type="text/javascript">
import _ from 'lodash';
import $ from 'jquery';
export default {
  name: 'tr-zoom-in',
  props: {
    width: {
      type: null,
      default: function () {
        return {};
      },
    },
    height: {
      type: null,
      default: function () {
        return {};
      },
    },
    name: {
      type: null,
      default: function () {
        return {};
      },
    },
    area: {
      type: null,
      default: function () {
        return {};
      },
    },
  },
  data: function () {
    return {
      // showModal: false
    };
  },
  mounted: function () {
    if (this.name === 'modal-zoomIn') {
      let test = require('dragscroll');
      test.reset();
      let $mainElement = $('#very-specific-design');
      let bounds = {
        width: parseInt(this.zoomInCenterfoldWidth),
        height: parseInt(this.zoomInCenterfoldHeight),
      };
      // console.log( 'bounds', bounds );
      // console.log( 'scale', this.$store.getters.scale );
      this.$store.commit('ZOOMIN_CENTERFOLD_CHANGE', bounds);
      let zoomInPage = this.$el.querySelector('.dragscroll');
      zoomInPage.scrollLeft = (this.zoomInCenterfoldWidth * this.area.x) / 100;
      zoomInPage.scrollTop = (this.zoomInCenterfoldHeight * this.area.y) / 100;
    } else if (this.name === 'modal-gallery-zoom') {
      let test = require('dragscroll');
      test.reset();
      let $mainElement = $('#very-specific-design');
      let bounds = {
        width: parseInt(this.zoomInCenterfoldWidth),
        height: parseInt(this.zoomInCenterfoldHeight),
      };
      // console.log( 'bounds', bounds );
      // console.log( 'scale', this.$store.getters.scale );
      this.$store.commit('ZOOMIN_CENTERFOLD_CHANGE', bounds);
      let zoomInPage = this.$el.querySelector('.dragscroll');
      zoomInPage.scrollLeft = (this.zoomInCenterfoldWidth * this.area.x) / 100;
      zoomInPage.scrollTop = (this.zoomInCenterfoldHeight * this.area.y) / 100;
    }
  },
  methods: {
    closeZoomIn() {
      this.$store.commit('SHOW_ZOOMIN', false);
      this.$store.commit('ZOOMIN_ACTIVE', false);
      this.$store.commit('TOGGLE_UI_DISABLE', false);
      this.$store.commit('IMAGE_ZOOM_DEACTIVATE');
    },
  },
  computed: {
    modalWidth: function () {
      return this.width + '%';
    },
    modalHeight: function () {
      return this.height + '%';
    },
    audioStyle: function () {
      return this.audioCss ? true : false;
    },
    zoomInCenterfoldWidth: function () {
      return this.$store.getters.zoomInCenterfoldWidth;
    },
    zoomInCenterfoldHeight: function () {
      return this.$store.getters.zoomInCenterfoldHeight;
    },
    zoomInActive() {
      return this.$store.getters.zoomInActive;
    },
    imageZoomActive() {
      return this.$store.getters.imageZoomActive;
    },
    getTooltips() {
      return this.$store.getters.getTooltips;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/sass/variable';
.modal-mask {
  position: fixed;
  z-index: 9995;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  z-index: 9996;
  position: inherit;
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  /*width: 300px;*/
  position: inherit;
  margin: 0 auto;
  z-index: 9997;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
  /*display: flex;
  justify-content: center;*/
}

.modal-default-button {
  float: right;
}
// The following styles are auto-applied to elements with transition="modal"
//  when their visibility is toggled by Vue.js. You can easily play with the
//   modal transition by editing these styles.
.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);

  .close-button {
    opacity: 0;
    transition: opacity 2s ease;
  }
}
.close-button {
  position: absolute;
  top: 0;
  right: 0;
  opacity: 1;
  z-index: 10000;
  cursor: pointer;
  outline: none;
  background-color: transparent;
  border: none;
  // opacity: 1;
  transition: opacity 2s ease;
  display: flex;
  transform: scale(1);
  svg {
    width: 45px;
    height: 45px;
  }
  &:hover {
    svg {
      path:first-child {
        fill: #5d5d5d;
        transition: all 0.4s ease;
      }
    }
    background-color: $borderColor;
    transform: scale(1.1);
    transition: all 0.4s ease;
    // opacity: 1;
  }
  img {
    width: 100%;
    height: 100%;
  }
}
.zoom-in-close-button {
  background-color: rgba(0, 0, 0, 0.15);
  border-radius: 50%;
  top: 16px !important;
  right: 16px !important;
  padding: 0;
}
.zoom-in-modal-body-class {
  margin: 10px !important;
  padding: 0 !important;
}
.zoom-in-modal-container-class {
  margin: 0 !important;
  padding: 0 !important;
}
.image-zoom-active-class {
  padding: 2px !important;
  margin: 0 !important;
}
</style>
